const tenMinutesInSeconds = 600;
const oneSecondInMilliseconds = 1000;
const oneHourInSeconds = 3600;

export const cacheRefreshVarianceMS =
  tenMinutesInSeconds * oneSecondInMilliseconds;
export const defaultCacheRefreshMS = oneHourInSeconds * oneSecondInMilliseconds;
